import React, { useContext, useEffect, useState } from 'react';
import { apiGet } from '../../utils/apiFetch';
import apiPath from '../../utils/apiPath';
import AgentTable from './AgentTable';
import Pagination from '../Pagination';
import dayjs from 'dayjs';
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker';
import { useTranslation } from 'react-i18next';
import AuthContext from 'context/AuthContext';
import AgentModal from './AddAgent';
import EditAgentModal from './EditAgentModal';
import ResetPasswordModal from './ResetPasswordModal';

function Agent() {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const manager =
    user?.permission?.find((e) => e.manager === 'agent_manager') ?? {};
  const [showModal, setShowModal] = useState(false);
  const [editShowModal, setEditShowModal] = useState(false);
  const [agent, setAgent] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [item, setItem] = useState('');
  const [isDelete, setIsDelete] = useState(false);
  const [totalAgents, setTotalAgents] = useState(1);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [filterData, setFilterData] = useState({
    category: '',
    searchkey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc',
  });
  const [resetPasswordModal, setResetPasswordModal] = useState(false);
  const { category, startDate, endDate, searchkey, isFilter } = filterData;
  const allAgent = async (data) => {
    try {
      if (
        (data?.deletePage && !(agent?.length > 1)) ||
        (isFilter && category && data?.statusChange && !(agent?.length > 1))
      ) {
        setPage(page - 1);
        setIsDelete(true);
        setPaginationObj({ ...paginationObj, page: page - 1 });
      } else {
        setIsDelete(false);
      }

      const payload = {
        page,
        pageSize: pageSize,
        status: category,
        startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        keyword: searchkey?.trim(),
        sortKey: sort.sortKey,
        sortType: sort.sortType,
      };

      const path = apiPath.getAgents;
      const result = await apiGet(path, payload);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      setTotalAgents(resultStatus ? response.totalDocs : 0);
      setAgent(response?.docs);
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null,
      });
      // }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message);
    }
  };
  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };
  const handelEdit = (newItem) => {
    setItem(newItem);
    setEditShowModal(true);
  };

  useEffect(() => {
    allAgent();
  }, [
    startDate,
    endDate,
    isFilter,
    searchkey,
    category,
    page,
    sort,
    filterData,
  ]);

  const handleChangeData = (e) => {
    setFilterData({ ...filterData, searchkey: e.target.value, isFilter: true });
    setPage(1);
  };

  const handleReset = () => {
    setFilterData({
      category: '',
      searchkey: '',
      startDate: '',
      endDate: '',
      isReset: true,
      isFilter: false,
    });
    setPage(1);
  };

  const handleDateChange = (start, end) => {
    setPage(1);
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };
  const statusPage = (e) => {
    setPage(1);
    setFilterData({ ...filterData, category: e.target.value, isFilter: true });
  };

  const handleResetPassword = (item) => {
    setItem(item);
    setResetPasswordModal(true);
  };

  return (
    <div>
      <div className="bg-white">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] ">
            {/* filter section */}
            <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3">
              <div className="col-span-2 flex flex-wrap  items-center">
                <div className="flex items-center lg:pt-0 pt-3 flex-wrap justify-center mb-2 2xl:mb-0">
                  {/* <div className='flex items-center mb-3 sm:mb-0'>
                  <label className='mx-2 text-[#B8BBBF] text-xs'>From</label>
                  <DatePicker
                    className='flex flex-row-reverse border border-[#E9EDF9] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                    value={startDate}
                    onChange={(e) => setStartDate(e)}
                    maxDate={endDate}
                    format='dd-MM-yyyy'
                    clearIcon=''
                    yearPlaceholder='yy'
                    dayPlaceholder='dd'
                    monthPlaceholder='mm'
                  />

                </div>
                <div className='flex items-center  mb-3 sm:mb-0'>
                  <label className='mx-2 text-[#B8BBBF] text-xs'>To</label>
                  <DatePicker
                    className='flex flex-row-reverse border border-[#E9EDF9] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                    value={endDate}
                    onChange={(e) => setEndDate(e)}
                    minDate={startDate}
                    format='dd-MM-yyyy'
                    clearIcon=''
                    yearPlaceholder='yy'
                    dayPlaceholder='dd'
                    monthPlaceholder='mm'
                  />
                </div> */}
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />
                  <div className="flex items-center  ml-3 mb-3">
                    <select
                      id=""
                      type="text "
                      name="category"
                      className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                      onChange={(e) => statusPage(e)}
                      value={filterData?.category}
                    >
                      <option defaultValue value="">
                        {t('O_ALL')}
                      </option>
                      <option value="active">{t('O_ACTIVE')}</option>
                      <option value="inactive">{t('O_INACTIVE')}</option>
                    </select>
                  </div>

                  {/* <OButton
                  label={{t(O_RESET)}}
                  type='button'
                  onClick={handleReset}
                  extraClasses='ml-3'
                  style={{ borderRadius: '0.5rem' }}
                /> */}
                  <button
                    type="button"
                    onClick={handleReset}
                    className="bg-[#8FC150] text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2"
                  >
                    {t('O_RESET')}
                  </button>

                  {/* <button
                  type='button'
                  onClick={handleReset}
                  className='bg-[#8FC150] text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
                >
                  Reset
                </button> */}
                </div>
              </div>

              <div className="2xl:ml-auto xl:ml-0 lg:pt-0 pt-2">
                <label
                  htmlFor="default-search"
                  className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                >
                  {t('O_SEARCH')}
                </label>
                <div className="flex">
                  <div className="relative ">
                    <div className="absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none">
                      <svg
                        aria-hidden="true"
                        className="w-4 h-4 text-[#A5A5A5] dark:text-gray-40"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {!filterData?.searchkey && (
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        )}
                      </svg>
                    </div>
                    <input
                      type="search"
                      id="default-search"
                      title=""
                      className="block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[300px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder={t(
                        'SUB_ADMIN_SEARCH_BY_USER_NAME_EMAIL_MOBILE'
                      )}
                      value={filterData?.searchkey}
                      required
                      onChange={(e) => handleChangeData(e)}
                    />
                  </div>
                  {(manager?.add || user?.role === 'admin') && (
                    <button
                      title={t('ADD_AGENT')}
                      type="button"
                      className="bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap"
                      onClick={() => setShowModal(true)}
                    >
                      + {t('ADD_AGENT')}
                    </button>
                  )}
                </div>
              </div>
            </form>
            <AgentTable
              agent={agent}
              page={page}
              setSort={setSort}
              handleResetPassword={handleResetPassword}
              sort={sort}
              allAgent={allAgent}
              handelEdit={handelEdit}
              manager={manager}
              paginationObj={paginationObj}
            />
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                isDelete={isDelete}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>

      <>
        {showModal ? (
          <AgentModal
            setShowModal={setShowModal}
            allAgent={allAgent}
            totalAgents={totalAgents}
          />
        ) : null}
        {editShowModal && (
          <EditAgentModal
            setEditShowModal={setEditShowModal}
            allAgent={allAgent}
            item={item}
            totalAgents={totalAgents}
          />
        )}

        {resetPasswordModal && (
          <ResetPasswordModal
            item={item}
            setResetPasswordModal={setResetPasswordModal}
          />
        )}
      </>
    </div>
  );
}

export default Agent;
